import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from './ui/card';
import { TrendingUp, Loader2 } from 'lucide-react';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { API } from '../config/api';

export default function MonthlyTrendPanel() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/stats/monthly`, { withCredentials: true })
      .then((r) => setItems(r.data.items))
      .catch(() => setItems([]));
  }, []);

  if (items === null) {
    return (
      <Card className="border-[#E9DDCC] rounded-2xl">
        <CardContent className="p-6 flex items-center justify-center">
          <Loader2 className="w-5 h-5 animate-spin text-[#C99A55]" />
        </CardContent>
      </Card>
    );
  }

  const fmtMonth = (m) => {
    const [y, mo] = m.split('-');
    const names = ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];
    return `${names[parseInt(mo, 10) - 1]} ${y.slice(2)}`;
  };
  const data = items.map((i) => ({ ...i, label: fmtMonth(i.month) }));

  return (
    <Card className="border border-[#E9DDCC] rounded-2xl bg-white" data-testid="monthly-trend-panel">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-1">
          <TrendingUp className="w-4 h-4 text-[#C99A55]" strokeWidth={1.8} />
          <span className="text-[10px] uppercase tracking-[0.2em] text-[#C99A55] font-semibold">Évolution mensuelle</span>
        </div>
        <h3 className="font-heading text-lg text-[#493329] mb-4">Inscriptions & CA confirmé cumulé</h3>
        {data.length === 0 ? (
          <p className="text-sm text-[#7A6455]">Pas encore de données mensuelles.</p>
        ) : (
          <div className="h-72" data-testid="monthly-trend-chart">
            <ResponsiveContainer width="100%" height="100%">
              <ComposedChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#EFE4D0" />
                <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#7A6455' }} />
                <YAxis yAxisId="left" tick={{ fontSize: 11, fill: '#7A6455' }} allowDecimals={false} />
                <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 11, fill: '#C99A55' }} tickFormatter={(v) => `${v}€`} />
                <Tooltip formatter={(v, name) => name === 'CA confirmé cumulé' ? [`${Math.round(v).toLocaleString('fr-FR')} €`, name] : [v, name]} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Bar yAxisId="left" dataKey="inscriptions" name="Inscriptions" fill="#E9DDCC" radius={[4, 4, 0, 0]} />
                <Bar yAxisId="left" dataKey="confirmees" name="Confirmées" fill="#C99A55" radius={[4, 4, 0, 0]} />
                <Line yAxisId="right" type="monotone" dataKey="ca_cumule" name="CA confirmé cumulé" stroke="#493329" strokeWidth={2} dot={{ r: 3 }} />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        )}
        <p className="text-[11px] text-[#AE9885] italic mt-3">
          Le CA cumulé n'inclut que les clientes confirmées, au tarif réellement payé (−20% ou normal).
        </p>
      </CardContent>
    </Card>
  );
}
